import { CommonDialogs } from "@mcleod/common";
import { Snackbar } from "@mcleod/components";
import { StringUtil } from "@mcleod/core";
import { AutogenLayoutBuildRangeFAKProfile } from "./autogen/AutogenLayoutBuildRangeFAKProfile";

export class BuildRangeFAKProfile extends AutogenLayoutBuildRangeFAKProfile {

    public whenValidationFailedResetTextbox(response: any, message: string) {
        const resetLowClass = response?.data[0]?.reset_low_class;
        const resetHighClass = response?.data[0]?.reset_high_class;
        const resetBoth = response?.data[0]?.reset_both;

        if (resetLowClass) {
            this.textboxActualLowClass.text = null;
            this.textboxActualLowClass["lookupModelData"] = null;
        }
        if (resetHighClass) {
            this.textboxActualHighClass.text = null;
            this.textboxActualHighClass["lookupModelData"] = null;
        }
        if (resetBoth) {
            this.textboxActualLowClass.text = null;
            this.textboxActualLowClass["lookupModelData"] = null;
            this.textboxActualHighClass.text = null;
            this.textboxActualHighClass["lookupModelData"] = null;
        }

        Snackbar.showWarningSnackbar(message, { millisUntilDismissal: 3000, persist: false });
    }

    resetFakRangeInSlideOut() {
        this.textboxActualLowClass.text = null;
        this.textboxActualLowClass["lookupModelData"] = null;
        this.textboxActualHighClass.text = null;
        this.textboxActualHighClass["lookupModelData"] = null;
        this.textboxRatedClass.text = null;
        this.textboxRatedClass["lookupModelData"] = null;
    }

    getRequestBody() {
        const actualLow = this.textboxActualLowClass.getDataValue();
        const actualHigh = this.textboxActualHighClass.getDataValue();
        const rated = this.textboxRatedClass.getDataValue();
        return { actualLow, actualHigh, rated };
    }

    validateRequiredFields(actualLow: string, actualHigh: string, rated: string): boolean {
        const errorTitle = "FAK Range Validation";
        if (StringUtil.isEmptyString(actualLow)) {
            CommonDialogs.showMessage("Actual Low Class is required to generate the NMFC Override Ratings.", errorTitle);
            return true;
        }
        if (StringUtil.isEmptyString(actualHigh)) {
            CommonDialogs.showMessage("Actual High Class is required to generate the NMFC Override Ratings.", errorTitle);
            return true;
        }
        if (StringUtil.isEmptyString(rated)) {
            CommonDialogs.showMessage("Rated Class is required to generate the NMFC Override Ratings.", errorTitle);
            return true;
        }
        return false;
    }

}
